export default "__VITE_ASSET__CZLbZBs9__"